import React, { useEffect, useState } from 'react';
import './CourseDetail.css'; // Import the CSS file
import { getCoursesById } from '../../../services/Trainer/trainer';
import { useParams } from 'react-router-dom';
const courseData = {
    "course": {
        "_id": "683b2f63d2e0b642129b90a6",
        "title": "Unlocking Radiance: A Journey Through Aesthetic Wellness",
        "description": "This course offers a guided experience into the world of aesthetic wellness, led by the expert team at The Beauty Clinic. Each video module brings you closer to understanding the science, care, and transformative power behind our signature treatments and philosophy.",
        "tags": ["one", "two"],
        "thumbnail": "/course/images/1750077409367image.png",
        "isVerified": true,
        "isDeleted": false,
        "isActive": true,
        "createdAt": "2025-05-31T16:33:39.113Z",
        "updatedAt": "2025-06-11T21:09:45.030Z",
        "__v": 0,
        "category": "",
        "quizes": []
    },
    "content": {
        "_id": "683b2f63d2e0b642129b90a8",
        "course": "683b2f63d2e0b642129b90a6",
        "videos": [
            {
                "title": "Welcome to The Beauty Clinic",
                "duration": "21.087733",
                "videoUrl": "/course/videos/1748709135760istockphoto-1875080667-640_adpp_is.mp4",
                "_id": "683b2f63d2e0b642129b90a9",
                "isCompleted": true
            },
            {
                "title": "The Philosophy of Beauty",
                "duration": "21.087733",
                "videoUrl": "/course/videos/1748709164727istockphoto-1875080667-640_adpp_is.mp4",
                "_id": "683b2f63d2e0b642129b90aa",
                "isCompleted": false
            }
        ],
        "courseMaterials": [
            {
                "title": "resume",
                "materialUrl": "/course/courseMaterials/1748709128841React_Js_Developer.pdf",
                "_id": "683b2f63d2e0b642129b90ab"
            }
        ],
        "quizes": [
            {
                "question": "question one",
                "correctOption": "1",
                "options": ["1", "2", "3", "4"],
                "viewMode": false
            }
        ],
        "createdAt": "2025-05-31T16:33:39.551Z",
        "updatedAt": "2025-05-31T16:33:39.551Z",
        "__v": 0,
        "quizLocked": true
    },
    "relatedCourses": [],
    "instructor": {
        "_id": "68208a79affa5289186d19ff",
        "fullName": "Empowering Beauty",
        "profileImageUrl": "/user/profile/1752098048016profile.png",
        "username": "naveedulhassan665@gmail.com",
        "role": "trainer",
        "isDeleted": false,
        "isActive": true,
        "isVerified": true,
        "createdAt": "2025-05-11T11:31:05.553Z",
        "updatedAt": "2025-07-14T17:59:22.264Z",
        "__v": 0,
        "isApproved": true,
        "privateChat": "private-68208a79affa5289186d19ff"
    },
    "totalDuration": 42.175466
};

const CourseDetail = ({ }) => {
    //   const { course, content, instructor, totalDuration } = courseData;
    const [allCourseLoading, setAllCourseLoading] = useState(false)
    const { id } = useParams()
    const [allCoursesData, setAllCoursesData] = useState()

    const fetchCourseData = async () => {
        setAllCourseLoading(true)
        let data = await getCoursesById(id);
        if (data) {
            console.log("data>>>", data)
            setAllCoursesData(data?.data)
        }
        setAllCourseLoading(false)

    }
    useEffect(() => {
        if (id) {
            fetchCourseData()

        }
    }, [id])

    const formatDuration = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = Math.floor(seconds % 60);
        return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
    };

    const formatTotalDuration = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        return `${minutes} minutes`;
    };

    return (
        <div className="course-detail course-page">
            {
                allCoursesData ?
                    <>
                        <div className="course-detail course-header">
                            <div className="container">
                                <div className="row align-items-center">
                                    <div className="col-lg-8">
                                        <h1 className="course-detail course-title">{allCoursesData?.course.title}</h1>
                                        <p className="course-detail course-subtitle">
                                            Brought to you by Empowering Beauty – Where Confidence Meets Care
                                        </p>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="course-detail video-thumbnail">
                                            <img
                                                src={`${process.env.REACT_APP_BUCKET_URL}${allCoursesData?.course.thumbnail}`}
                                                alt={allCoursesData?.course.title}
                                            />
                                            <div className="course-detail play-button">
                                                <div className="course-detail play-icon"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Description Section */}
                        <div className="course-detail description-section">
                            <div className="container">
                                <div className="row">
                                    <div className="col-12">
                                        <h2 className="course-detail section-title">Description</h2>
                                        <p className="course-detail description-text">
                                            {allCoursesData?.course.description || "This course offers a guided experience into the world of aesthetic wellness..."}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Course Content Section */}
                        <div className="course-detail content-section">
                            <div className="container">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="course-detail content-header">
                                            <h2 className="course-detail section-title">Course Content</h2>
                                        </div>
                                        {allCoursesData?.content.videos.map((video) => (
                                            <div key={video._id} className="course-detail video-item">
                                                <div className="d-flex align-items-center">
                                                    <div>
                                                        <h3 className="course-detail video-title">{video.title}</h3>
                                                    </div>
                                                </div>
                                                {video.duration && 
                                                <div className="course-detail video-duration">
                                                    
                                                    {formatDuration(parseFloat(video.duration))} minutes
                                                </div>
                                                }
                                                
                                            </div>
                                        ))}

                                        {/* <div className="mt-3">
                <h5 className="text-muted">
                  Total Duration: {formatTotalDuration(totalDuration)}
                </h5>
              </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                    :
                    <div className="col-md-12" style={{ height: '40vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <div class="spinner-border spinner-border-sm" role="status"></div>
                    </div>

            }
            {/* Course Header */}

        </div>
    );
};

export default CourseDetail;
